// extracted by mini-css-extract-plugin
module.exports = {"container":"container__27BXu","title":"title__yTXaI","description":"description__3dg4c","image":"image__1ARLE","caption":"caption__2_o6a"};